// extracted by mini-css-extract-plugin
module.exports = {"base":"citationsList_base__3iZXA","title":"citationsList_title__3bXr6","active":"citationsList_active__2Rjss","hidden":"citationsList_hidden__eUv-F"};